function Footer() {
    return (
        <footer className="w-full bg-gradient-to-r from-primary-800 via-primary-700 to-primary-800 sticky top-[100vh] border-t-4 border-primary-600">
            <div className="max-w-6xl mx-auto px-6 py-12">
                {/* Main Footer Content */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
                    
                    {/* Brand Section */}
                    <div className="space-y-4">
                        <h3 className="text-2xl font-bold text-pearl-50 font-japanese flex items-center justify-center md:justify-start">
                            🌸 読んで 
                        </h3>
                    </div>

                    {/* Quick Links */}
                    <div className="space-y-4">
                        <h4 className="text-lg font-semibold text-sage-300">Enlaces Rápidos</h4>
                        <ul className="space-y-2 text-pearl-200 text-sm">
                            <li><a href="/" className="hover:text-japanese-cherry transition-colors duration-200">🏠 Inicio</a></li>
                            <li><a href="/cuentosDashboard" className="hover:text-japanese-cherry transition-colors duration-200">📚 Cuentos</a></li>
                            {/* <li><a href="#" className="hover:text-japanese-cherry transition-colors duration-200">📖 Sobre los Mukashibanashi</a></li>
                            <li><a href="#" className="hover:text-japanese-cherry transition-colors duration-200">🎌 Cultura Japonesa</a></li> */}
                        </ul>
                    </div>

                    {/* Cultural Info */}
                    <div className="space-y-4">
                        <h4 className="text-lg font-semibold text-sage-300">Aprende Japonés</h4>
                        <div className="text-pearl-200 text-sm space-y-2">
                            <p className="flex items-center justify-center md:justify-start">
                                <ruby className="text-japanese-cherry font-japanese text-base mr-2">
                                    <rb>読書</rb><rt className="text-xs">どくしょ</rt>
                                </ruby>
                                <span>Lectura</span>
                            </p>
                            <p className="flex items-center justify-center md:justify-start">
                                <ruby className="text-japanese-cherry font-japanese text-base mr-2">
                                    <rb>文化</rb><rt className="text-xs">ぶんか</rt>
                                </ruby>
                                <span>Cultura</span>
                            </p>
                            <p className="flex items-center justify-center md:justify-start">
                                <ruby className="text-japanese-cherry font-japanese text-base mr-2">
                                    <rb>学習</rb><rt className="text-xs">がくしゅう</rt>
                                </ruby>
                                <span>Aprendizaje</span>
                            </p>
                        </div>
                    </div>
                </div>

                {/* Divider */}
                <div className="border-t border-primary-600 mt-8 pt-6">
                    <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
                        <p className="text-pearl-300 text-sm">
                            © 2025 Yonde
                        </p>
                        <div className="flex items-center space-x-4 text-pearl-300 text-sm">
                            <span>Hecho con</span>
                            <span className="text-japanese-cherry text-lg">❤️</span>
                            <span>para estudiantes de japonés</span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;